import { z } from 'zod';

/**
 * POST /api/provision-jobs/product リクエスト・レスポンスの型定義
 * エラーレスポンスは共通の types/errors.ts を参照すること。
 */

/** POST /api/provision-jobs/product リクエストボディの型 */
export type ProvisionJobRequest = {
  product: {
    product_name: string;
    external_product_id: string;
    team: string;
    budget: string;
    purpose: string;
    purpose_detail?: string | null;
  };
  invited_users: Array<{
    email: string;
    github_account: string;
  }>;
};

/** POST /api/provision-jobs/product レスポンスボディの Zod スキーマ */
export const ProvisionJobResponseSchema = z.object({
  product_id: z.string().uuid('product_id must be a valid UUID'),
});

/** POST /api/provision-jobs/product レスポンスボディの型 */
export type ProvisionJobResponse = z.infer<typeof ProvisionJobResponseSchema>;
